// eslint-disable-next-line no-restricted-imports
import { camelCaseKeys, useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import * as z from "zod";

import { FEMarketingBanner, flags, Flags, GlobalCallout } from "../views/flags";

const parseFeMarketingBanners = (feMarketingBanners: unknown): FEMarketingBanner[] => {
  const FEMarketingBanners = z.array(FEMarketingBanner);
  const { success, data } = FEMarketingBanners.safeParse(feMarketingBanners);

  if (success) {
    return data;
  }
  return [];
};

const parseFeGlobalCallout = (value: unknown): GlobalCallout => {
  const { success, data } = GlobalCallout.safeParse(value);
  return success ? data : null;
};

const useTypedFlags = () => {
  const ldFlags = useFlags<Flags>();

  // Reading a flag off the SDK's proxy reports an evaluation, and each report costs a
  // setTimeout, so the spread runs only when the flags themselves change.
  return useMemo(() => {
    /**
     * There is an issue with the LaunchDarkly SDK where it returns an empty object
     * if there is some problem with the LD initialization, like network issues.
     * LaunchDarkly is aware of this and say this is the expected behavior.
     * https://support.launchdarkly.com/hc/en-us/articles/16441198122523-React-Web-SDK-does-not-serve-fallback-values-for-flags-when-SDK-client-fails-initialization
     */
    if (Object.keys(ldFlags || {}).length === 0) {
      return camelCaseKeys(flags) as Flags;
    }

    return {
      ...ldFlags,
      feMarketingBanners: parseFeMarketingBanners(ldFlags.feMarketingBanners),
      feGlobalCallout: parseFeGlobalCallout(ldFlags.feGlobalCallout),
    };
  }, [ldFlags]);
};

export default useTypedFlags;
